import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '@environments/environment';
import { NoResultComponent } from '../../../no-result/no-result.component';
import {
  SkeletonBannerComponent,
  SkeletonTrendingNewsComponent,
} from '../../../skeleton';

@Component({
  selector: 'app-pre-render-right-menu',
  standalone: true,
  imports: [
    SkeletonTrendingNewsComponent,
    NoResultComponent,
    SkeletonBannerComponent,
  ],
  templateUrl: './pre-render-right-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreRenderRightMenuComponent {
  urlIcon = environment.urlIcon;
}
